import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import {
  postMember3,
  postMember4,
  postMobile1,
  postMobile2,
} from "../../common/redux/MasterLayoutCRUD";
import { appGamesSlice } from "./AppGamesSlice";

const { actions } = appGamesSlice;

export const getAppGamesPageUI = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMobile2(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.appGamesPageUIFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchAppGamesPageUI");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const clearPromotion = () => (dispatch) => {
  dispatch(actions.clearPromotion());
};

export const addAppGamesID = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postMember3(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.appGameIDcreated({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: createAppGameID");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const editAppGamesID = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postMember4(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.appGamePasswordReseted({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: resetAppGamePassword");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
